import React, {ReactNode} from "react"
import "./button-contact.scss"

type Props = {
  children: ReactNode
}

export const ButtonContact = ({children}: Props) => {
  return (
    <a href="/contacts" className="button__contact">
      {children}
    </a>
  )
}
